import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box} from 'views/components';

import JobTitle from './title/JobTitle';
import JobDescription from './description/JobDescription';
import JobShowSettings from './JobShowSettings';

const JobHeader = (props) => {
  const {
    jobData,
    client,
    jobBackend,
    refresh,
    setRefresh,
    showSettings,
    setOpenDrawerView,
  } = props;
  return (
    <Stack>
      <JobTitle
        jobData={jobData}
        client={client}
        jobBackend={jobBackend}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <Box
        sx={{
          px: 2,
        }}
      >
        <JobDescription
          jobData={jobData}
          jobBackend={jobBackend}
        />
      </Box>
      <JobShowSettings
        showSettings={showSettings}
        setOpenDrawerView={setOpenDrawerView}
      />
    </Stack>
  );
};
JobHeader.propTypes = {
  jobData: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  jobBackend: PropTypes.object.isRequired,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
  showSettings: PropTypes.bool.isRequired,
  setOpenDrawerView: PropTypes.func.isRequired,
};

export default React.memo(JobHeader);
